import { Icon } from '@iconify/react';

const EstadoBloqueoBadge = ({ estado }) => {
  let color = 'gray';
  let icon = 'mdi:help-circle-outline'; // icono por defecto

  switch (estado) {
    case 'Vigente':
      color = 'green';
      icon = 'mdi:check-circle-outline';
      break;
    case 'Pendiente':
      color = 'orange';
      icon = 'mdi:clock-outline';
      break;
    case 'Expirado':
      color = 'red';
      icon = 'mdi:close-circle-outline';
      break;
    default:
      color = 'gray';
      icon = 'mdi:help-circle-outline';
  }

  return (
    <span style={{ color, display: 'flex', alignItems: 'center', gap: '4px' }}>
      <Icon icon={icon} width={18} height={18} />
      {estado || 'Desconocido'}
    </span>
  );
};

export default EstadoBloqueoBadge;
